var render = function render(){var _vm=this,_c=_vm._self._c;return _c('radio-group',{attrs:{"value":_vm.value,"label":_vm.label,"options":_vm.options,"testid":_vm.testid,"length":'long',"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', arguments[0])}}})
}
var staticRenderFns = []

export { render, staticRenderFns }